import { render } from "./TrainingCalendar.vue?vue&type=template&id=f6eee6f2"
import script from "./TrainingCalendar.vue?vue&type=script&lang=js"
export * from "./TrainingCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__